import { MouseEventHandler, ReactNode } from 'react';
import styled from 'styled-components';

import { Icon } from 'components/Icon';
import { colors } from 'theme';

import { ButtonWithStyles } from './ButtonWithStyles';

const StyledCloseButton = styled(ButtonWithStyles)`
  padding: 8px 12px 8px 0;
  color: ${colors.lightContentGrey};
  &:hover {
    color: ${colors.brandBlue};
    &:disabled {
      &:hover {
        color: ${colors.lightContentGrey};
      }
    }
  }
  background-color: transparent;
  border-radius: 0;
`;

type Props = {
  children?: ReactNode;
  'data-qa-id'?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  onMouseDown?: MouseEventHandler<HTMLButtonElement>;
  className?: string;
};

export function CloseButton({ children, ...props }: Props) {
  return (
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledCloseButton value="Close" p={0} {...props}>
      {children || <Icon name="close" size={13} />}
    </StyledCloseButton>
  );
}

export const ClearButton = styled(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (props: any) => (
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/jsx-props-no-spreading
    <CloseButton value={getText('Clear')} {...props} />
  ),
)<{ $visible: boolean }>`
  visibility: ${(props) => (props.$visible ? 'visible' : 'hidden')};
  pointer-events: ${(props) => (props.$visible ? 'all' : 'none')};
`;
